// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d7nf","comment":"styles_comment__Eaw7-"};